<template>
  <el-row class="topic-container">
    <el-col :span="20" :class="[!isView && highlightTopicIndex === order ? 'highlight' : '']">
      <el-card>
        <div class="topic" @click="$emit('hightlight', order)">
          <div class="topic-header">
              <span class="index">{{ order + 1 }}.</span>
              <span class="required" v-if="topic.isRequired">*</span>
              <span class="name">{{ topic.name }} <span class="en-start">[</span>{{topic.nameEn}}<span class="en-end">]</span></span>
              <span class="type">[{{ topicTypeOptions.find(v => v.value === topic.type).label }}]</span>
              <span class="notAnswered" v-if="isShowUserAnswer && !topic.answer">&nbsp;[未作答]</span>
          </div>

          <div class="topic-option" v-if="topic.type === 1">
            <div class="topic-option-item" v-for="(option, optionIndex) in optionList" :key="optionIndex">
              <div class="radio"></div>
              <div class="radio-selected" v-if="isShowUserAnswer && topic.answer && topic.answer.optionId === option.id"></div>
              <div>{{ optionIndex > 25 ? optionIndex : String.fromCharCode(optionIndex + 65) }}.</div>
              <div v-if="!option.isOther" class="description">{{ option.description }} <span class="en-start">[</span>{{`${option.descriptionEn}`}}<span class="en-end">]</span></div>
              <div v-else class="other">
                  <span>其他 <span class="en-start">[</span>Other<span class="en-end">]</span></span>
                  <div class="other-input" v-if="isShowUserAnswer">{{isShowUserAnswer && topic.answer && topic.answer.optionId === option.id ? topic.answer.otherOptionAnswer : ''}}</div>
                </div>
              <div class="option-score">{{`(${option.score}分)`}}</div>
            </div>
          </div>

          <div class="topic-option" v-if="topic.type === 2">
            <div class="topic-option-item" v-for="(option, optionIndex) in optionList" :key="optionIndex">
              <div class="checkbox"></div>
              <div class="checkbox-selected" v-if="isShowUserAnswer && topic.answer && topic.answer.includes(option.id)"></div>
              <div>{{ optionIndex > 25 ? optionIndex : String.fromCharCode(optionIndex + 65) }}.</div>
              <div class="description">{{ option.description }} <span class="en-start">[</span>{{`${option.descriptionEn}`}}<span class="en-end">]</span></div>
            </div>
          </div>

          <div class="topic-option" v-if="topic.type === 3">
            <div class="topic-option-item">
              <div class="answer">{{ isShowUserAnswer && topic.answer ? topic.answer : '请输入答案' }}</div>
            </div>
          </div>

          <div class="topic-option" v-if="topic.type === 4">
            <div class="topic-option-item">
              <div v-for="score in parseInt(optionList[0].description)" :key="score" :class="['score', isShowUserAnswer && topic.answer && topic.answer >= score ? 'score-selected' : '']">
                {{ score }}
              </div>
            </div>
          </div>

        </div>
      </el-card>
    </el-col>
    <el-col :span="4">
      <div class="operation" v-show="!isView && highlightTopicIndex === order">
        <el-button size="mini" @click="$emit('topicEdit')">编辑</el-button>
        <el-button size="mini" @click="$emit('topicCopy')">复制</el-button>
        <el-button size="mini" @click="$emit('topicMoveUp')">上移</el-button>
        <el-button size="mini" @click="$emit('topicMoveDown')">下移</el-button>
        <el-button size="mini" @click="$emit('topicDel')">删除</el-button>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { topicTypeOptions } from '@/const/crud/app/questionnaire';

export default {
  name: 'TopicCard',
  props: {
    topic: {
      type: Object,
      default: () => ({}),
    },
    highlightTopicIndex: {
      type: Number,
      default: 0,
    },
    order: {
      type: Number,
      default: 0,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    isShowUserAnswer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    optionList() {
      return this.isShowUserAnswer ? this.topic.optionVOList : this.topic.optionList;
    },
  },
  data() {
    return {
      topicTypeOptions,
    }
  },
}
</script>

<style lang="scss" scoped>
.topic-container {
  margin: 0px 0px 20px 0px;
  padding:10px;
  color: #606266;
  font-size: 14px;
  border-radius: 8px;
  .topic {
    padding: 20px;
    &-header {
      margin-bottom:12px;
      .index {
        font-weight: 600;
      }
      .required {
        color: #f56c6c;
      }
      .name {
        margin: 0 6px;
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap !important;
        .en-start,
        .en-end {
          color: #5383f3;
        }
      }
      .notAnswered,
      .type {
        color: #5383f3;
        font-size: 12px;
      }
      .notAnswered {
        color: #f56c6c;
      }
    }
    &-option {
      &-item {
        position: relative;
        display: flex;
        align-items:center;
        margin: 20px 0;
        div {
          margin-right: 6px;
        }
        .radio,
        .checkbox {
          height:12px;
          width:12px;
          min-width: 12px;
          border:1px solid #7d7d7d;
        }
        .radio {
          border-radius: 50%;
        }
        .option-score {
          font-size: 12px;
        }
        .checkbox {
          border-radius: 3px;
        }
        .radio-selected,
        .checkbox-selected {
          position: absolute;
          left: 3px;
          height: 8px;
          width: 8px;
          background-color: #2c74f3;
        }
        .radio-selected {
          border-radius: 50%;
        }
        .answer {
          width:100%;
          height:100px;
          padding: 2px 0px 0px 4px;
          border-radius:4px;
          border: 1px solid #c0c4cc;
        }
        .score {
          width:22px;
          height:22px;
          border-radius:50%;
          border:1px solid #7d7d7d;
          text-align:center;
          line-height:22px;
        }
        .score-selected {
          color: #ffe9fa;
          background-color: #5383f3;
        }
        .description {
          word-wrap: break-word;
          word-break: break-all;
          white-space: pre-wrap !important;
          .en-start,
          .en-end {
            color: #5383f3;
          }
        }
        .other {
          display: flex;
          align-items:center;
          &-description {
            word-wrap: break-word;
            word-break: break-all;
            white-space: pre-wrap !important;
          }
          &-input {
            width: 128px;
            min-height: 20px;
            margin-left: 10px;
            border-radius:4px;
            border: 1px solid #c0c4cc;
            word-wrap:break-word
          }
          .en-start,
          .en-end {
            color: #5383f3;
          }
        }
      }
    }
  }
  .operation {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 160px;
    button:first-child {
      margin-left: 10px;
    }
  }
}

.highlight {
  border: 1px dashed #5383f3;
  border-radius: 4px;
}

.el-card.is-always-shadow {
  border: 1px solid #ebeef5;
  box-shadow: 0 0px 12px rgba(0, 0, 0, 0.1);
}

/deep/ .el-card__body {
  padding: 0;
}
</style>